import request from '@/utils/request';

/**
 * Rolki (Reels) w panelu admina: dodatkowe rolki i rabaty na pakiety rolek
 * (pojedynczo i zbiorczo) oraz globalne ustawienia promocji.
 * Mutacje na użytkowniku zwracają pełny kształt `getUserReels`.
 */

export function getUserReels(userId) {
  return request({
    url: '/admin/users/' + userId + '/reels',
    method: 'get',
  });
}

export function grantUserReels(userId, data) {
  return request({
    url: '/admin/users/' + userId + '/reels/credits',
    method: 'post',
    data,
  });
}

export function revokeUserReels(userId, data) {
  return request({
    url: '/admin/users/' + userId + '/reels/credits/revoke',
    method: 'post',
    data,
  });
}

export function createUserReelDiscount(userId, data) {
  return request({
    url: '/admin/users/' + userId + '/reels/discounts',
    method: 'post',
    data,
  });
}

export function revokeUserReelDiscount(userId, discountId) {
  return request({
    url: '/admin/users/' + userId + '/reels/discounts/' + discountId,
    method: 'delete',
  });
}

export function bulkReels(data) {
  return request({
    url: '/admin/reels/bulk',
    method: 'post',
    data,
  });
}

export function getReelSettings() {
  return request({
    url: '/admin/reels/settings',
    method: 'get',
  });
}

export function updateReelSettings(data) {
  return request({
    url: '/admin/reels/settings',
    method: 'put',
    data,
  });
}

export function getReelsOverview() {
  return request({
    url: '/admin/reels/overview',
    method: 'get',
  });
}
